var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-iPhone_14_Pro_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iPhone_14_Pro_1",
    "data-name": "iPhone 14 Pro \\u2013 1",
    clipPath: "url(#clip-iPhone_14_Pro_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(-8 -8)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(8 8)",
    fill: "#f55d57"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(49.061 -19.443) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    y2: 50,
    transform: "translate(48 24.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    y2: 50,
    transform: "translate(73 48) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 12
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.4a6840afd1ae841373663393e297fd9d.svg";
export { ForwardRef as ReactComponent };